import { useState } from 'react';

import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { REFERRER_NAME } from 'consts/storageConsts';

import { selectUserReferrerFirstName } from 'selectors/user';

import { colors } from 'theme/colors';

import { getValueFromStorage } from 'utils/storage/storageHelper';

const DEFAULT_NAME = 'a friend';

const Text = styled.p`
  color: ${colors.darkGrey};
  font-size: 1rem;
`;
const Name = styled.span`
  font-weight: bold;
`;

export default function InvitedBy() {
  const referrerFirstName = useSelector(selectUserReferrerFirstName);
  const [referrerName, _] = useState(
    getValueFromStorage(REFERRER_NAME) || referrerFirstName || DEFAULT_NAME
  );

  return (
    <Text>
      Invited by{' '}
      <span role="img" aria-label="Green heart">
        💚
      </span>{' '}
      <Name>{referrerName}</Name>
    </Text>
  );
}
